module.exports = __webpack_public_path__ + "img/wlc.0dcf89bd.jpg";